import { useState,useEffect,useCallback } from "react";
import { useNavigate,useParams } from "react-router-dom";
import apiClient from "../../shared/API/apiClient";
import "../../styles/pages/reviewscreen.css";
import "../../styles/pages/principleView.css";
import { useLocation } from "react-router-dom";



const FA_MAP={
  "fa-submitted":"fa-solid fa-paper-plane",
  "fa-reviewed":"fa-solid fa-circle-check",
  "fa-approved":"fa-solid fa-check-double",
  "fa-locked":"fa-solid fa-lock",
  "fa-draft":"fa-solid fa-pen-to-square",
  "fa-notstarted":"fa-solid fa-clock",
  "fa-rework":"fa-solid fa-rotate-left",
  "fa-sendback":"fa-solid fa-rotate-left",
  "fa-markreviewed":"fa-solid fa-circle-check",
  "fa-view":"fa-solid fa-eye",
  "fa-list":"fa-solid fa-list",
  "fa-exclamation":"fa-solid fa-circle-exclamation",
  "fa-paperclip":"fa-solid fa-paperclip",
  "fa-calculator":"fa-solid fa-calculator",
  "fa-database":"fa-solid fa-database",
  "fa-flag":"fa-solid fa-flag",
  "fa-comment":"fa-solid fa-comment",
  "fa-comment-dots":"fa-regular fa-comment-dots",
  "fa-eye":"fa-solid fa-eye",
  "fa-circle-check":"fa-solid fa-circle-check",
  "fa-clock":"fa-solid fa-clock",
  "fa-check-double":"fa-solid fa-check-double"
};

const Icon=({name,className=""})=>{

  if(!name) return null;

  const resolved=
    FA_MAP[name] ??
    FA_MAP[`fa-${name}`] ??
    name ??
    "fa-solid fa-circle";

  return(
    <i
      className={`${resolved} ${className}`.trim()}
      aria-hidden="true"
    />
  );
};

const StatCard=({
  label,
  value,
  iconName,
  color,
  sublabel
})=>(

  <div className="stat-card">

    <div
      className="va-stat-card__icon"
      style={{
        backgroundColor:`${color}18`,
        color
      }}
    >

      <Icon name={iconName} />

    </div>

    <div>

      <div className="stat-title">

        {label}

      </div>

      <div
        className="stat-value"
        style={{color}}
      >

        {value ?? "0"}

      </div>

      {sublabel && (

        <div className="va-stat-card__label">

          {sublabel}

        </div>

      )}

    </div>

  </div>
);

const ViewBetails=()=>{

  const navigate=useNavigate();

  const {
  section,
  reportingYearId,
  orgId,
  legalEntityId,
  principleId
} = useParams();
const { state } = useLocation();
  const [loading,setLoading]=useState(true);

  const [error,setError]=useState("");

  const [detail,setDetail]=useState(null);

  const [summary,setSummary]=useState([]);

  const [disclosures,setDisclosures]=useState([]);

  const [evidence,setEvidence]=useState([]);

  const formatValue=(value)=>{

    if(
      value===null ||
      value===undefined ||
      value===""

    ){

      return "--";
    }

    if(
      value==="1" ||
      value===1
    ){

      return "Yes";
    }

    if(
      value==="0" ||
      value===0
    ){

      return "No";
    }

    return value;
  };

  const fetchDetail=useCallback(async()=>{

    if(
      !reportingYearId ||
      !legalEntityId ||
      !principleId
    ){

      return;
    }

    setLoading(true);

    setError("");

    try{

      const response=
        await apiClient.get(
          `/api/section-b/B/${reportingYearId}/${legalEntityId}/${principleId}`
        );

      if(response.data?.success){

        const data=response.data;

        setDetail({

          principle_id:
            data.principle?.principle_id,

          principle_code:
            data.principle?.principle_code,

          principle_name:
            data.principle?.principle_name,

          principle_description:
            data.principle?.principle_description,

          status_name:
            data.status?.name,

          status_code:
            data.status?.code,

          color_code:
            data.status?.color_code,

          fore_color:
            data.status?.fore_color,

          icon: data.status?.icon,
          
          legal_entity_name: data.legal_entity_name,
          reporting_year: data.reporting_year
        });

        setSummary([

          {
            label:"Total Disclosures",
            value:data.summary?.total_disclosures || 0,
            sublabel:"in preview",
            icon:"fa-list",
            color:"#1D4ED8"
          },

          {
            label:"Verified Disclosures",
            value:data.summary?.verified_disclosures || 0,
            sublabel:"approved",
            icon:"fa-circle-check",
            color:"#16A34A"
          },

          {
            label:"Evidence Attached",
            value:data.summary?.evidence_attached || 0,
            sublabel:"files",
            icon:"fa-paperclip",
            color:"#64748B"
          },

          {
            label:"Last Updated",
            value:data.summary?.last_updated || "-",
            sublabel:"source data",
            icon:"fa-clock",
            color:"#334155"
          }
        ]);

        setDisclosures(
          data.disclosures || []
        );

        setEvidence(
          data.evidence || []
        );

      }else{

        setError(
          "Failed to load Section B detail."
        );
      }

    }catch(err){

      console.error(
        "Section B detail fetch failed",
        err
      );

      setError(
        "Failed to load Section B detail."
      );

    }finally{

      setLoading(false);
    }

  },[
    reportingYearId,
    legalEntityId,
    principleId
  ]);

  useEffect(()=>{

    fetchDetail();

  },[fetchDetail]);

  const handleBack = () => {
  navigate("/dashboard/process-disclosures", {
    state,
  });
};

  const renderTable=(details=[])=>{

  if(
    !Array.isArray(details) ||
    !details.length
  ){

    return null;
  }

  const grouped={};

  details.forEach((item)=>{

    const rowIndex=item.row_index ?? 0;

    if(!grouped[rowIndex]){

      grouped[rowIndex]={};
    }

    grouped[rowIndex][item.field_key]=item.value;
  });

  const rows=Object.values(grouped);

  if(!rows.length){

    return null;
  }

  const headers=Object.keys(rows[0]);

  return(

    <div className="va-table-wrapper">

      <table className="va-table">

        <thead>

          <tr>

            {headers.map((header)=>(

              <th key={header}>

                {header
                  .replaceAll("_"," ")
                  .replace(/\b\w/g,char=>char.toUpperCase())}

              </th>

            ))}

          </tr>

        </thead>

        <tbody>

          {rows.map((row,rowIndex)=>(

            <tr key={rowIndex}>

              {headers.map((header)=>(

                <td key={header}>

                  {formatValue(
                    row[header]
                  )}

                </td>

              ))}

            </tr>

          ))}

        </tbody>

      </table>

    </div>
  );
};

  const renderEvidence=(files=[])=>{

    if(!files.length){

      return null;
    }

    return(

      <div className="va-evidence-wrapper">

        {files.map((file,index)=>(

          <a
            key={index}
            href={file.file_path}
            target="_blank"
            rel="noreferrer"
            className="va-evidence-link"
          >

            📎 {file.file_name}

          </a>

        ))}

      </div>
    );
  };

  const bgColor=
    detail?.color_code || "#F1F5F9";

  const fgColor=
    detail?.fore_color || "#334155";

  return(

    <div className="va-page">

     

      {/* HEADER */}

      <div className="va-heading">

        <h1 className="va-heading__title">

          {detail
            ? `${detail.principle_code} – ${detail.principle_name}`
            : "Loading..."
          }
{detail?.status_name && (

          <span
            className="va-status-pill"
            style={{
              background:bgColor,
              color:fgColor,
              borderColor:bgColor
            }}
          >

            <Icon
              name={detail.icon}
              className="status_icon_size"
            />

            {detail.status_name}

          </span>

        )}
        </h1>

        <p className="va-heading__desc">

          Section B Disclosure Previews

        </p>

        <div className="va-heading__meta">

          <span className="va-heading__readonly">

            <Icon name="fa-eye" />

            Read-only consolidated disclosures sourced from approved Principle submissions.

          </span>

        </div>
<div class="principle-meta-info">
<div class="principle-meta-item">
<span class="principle-meta-label">Reporting Year:</span>
<span class="principle-meta-value">{detail?.reporting_year || "2026-27"}</span></div>
<div class="principle-meta-item">
<span class="principle-meta-label">Legal Entity:</span>
<span class="principle-meta-value">{detail?.legal_entity_name || "--"}</span></div></div>
      </div>

      {/* SUMMARY */}

      {!!summary.length && (

        <div className="stats-row">

          {summary.map((item,index)=>(

            <StatCard
              key={index}
              label={item.label}
              value={item.value}
              sublabel={item.sublabel}
              iconName={item.icon}
              color={item.color}
            />

          ))}

        </div>

      )}

      {/* LAYOUT */}

      <div className="va-layout">

        {/* LEFT */}

        <div className="va-layout__main">

          <div className="va-panel">

            {loading && (

              <div className="va-state va-state--loading">

                <span className="va-spinner" />

                Loading...

              </div>

            )}

            {!!error && !loading && (

              <div className="va-state va-state--error">

                ⚠ {error}

              </div>

            )}

            {!loading && !error && !disclosures.length && (

              <div className="va-state va-state--empty">

                No approved disclosures available for preview.

              </div>

            )}

            {!loading && !error && disclosures.length > 0 && (

  <div className="va-submitted-wrapper">

    {disclosures.map((question)=>(

      <div
        key={question.question_id}
        className="va-question-card"
      >

        {/* QUESTION TOP */}

        <div className="va-question-top">

          <span className="va-q-code">

            {question.question_code}

          </span>

        </div>

        {/* QUESTION */}

        <h4 className="va-question-title">

          {question.question}

        </h4>

        {/* ANSWER */}

        {!question.has_itemised_data && (

          <div className="va-answer-box">

            {formatValue(
              question.answer
            )}

          </div>

        )}

        {/* MAIN TABLE */}

        {question.has_itemised_data &&

          renderTable(
            question.details
          )

        }

        {/* MAIN EVIDENCE */}

        {renderEvidence(
          question.evidence
        )}

        {/* =====================================
            RELATED DISCLOSURE
        ===================================== */}

        {question.related_disclosure && (

          <div
            className="va-question-card"
            style={{
              marginTop:"16px",
              background:"#fafafa"
            }}
          >

            {/* RELATED TOP */}

            <div className="va-question-top">

              <span className="va-q-code">

                {
                  question
                    .related_disclosure
                    .question_code
                }

              </span>

            </div>

            {/* RELATED QUESTION */}

            <h4 className="va-question-title">

              {
                question
                  .related_disclosure
                  .question
              }

            </h4>

            {/* RELATED ANSWER */}

            {!question
              .related_disclosure
              .has_itemised_data && (

              <div className="va-answer-box">

                {formatValue(
                  question
                    .related_disclosure
                    .answer
                )}

              </div>

            )}

            {/* RELATED TABLE */}

            {question
              .related_disclosure
              .has_itemised_data &&

              renderTable(
                question
                  .related_disclosure
                  .details
              )

            }

            {/* RELATED EVIDENCE */}

            {renderEvidence(
              question
                .related_disclosure
                .evidence
            )}

          </div>

        )}

      </div>

    ))}

  </div>

)}

          </div>

        </div>

        {/* RIGHT */}

        <div className="va-layout__sidebar">

          <div className="va-sidebar-card">

            <div className="va-sidebar-card__title">

              <Icon name="fa-paperclip" />

              Attached Evidence

              <span className="va-comment-count">

                {evidence.length} files

              </span>

            </div>

            {!!evidence.length && (

              <div className="va-evidence-block">

  {evidence.map((file,index)=>(

    <a
      key={index}
      href={file.file_url}
      target="_blank"
      rel="noreferrer"
      className="va-stat-card"
    >

      <div className="va-evidence-item__icon">

        <i className="fa-regular fa-file-lines" />

      </div>

     

        <div className="va-evidence-item__name">

          {file.file_name}

        </div>

       

     

    </a>

  ))}

</div>

            )}

            {!evidence.length && (

              <div
                className="va-state va-state--empty"
                style={{
                  padding:"16px"
                }}
              >

                No evidence attached.

              </div>

            )}

            <div
              className="va-heading__meta"
              style={{
                padding:"12px"
              }}
            >

              <span className="va-heading__readonly">

                <Icon name="fa-circle-check" />

                Evidence references are linked from the Audit Repository. Read-only.

              </span>

            </div>

          </div>

        </div>

      </div>

      {/* BACK */}

     <div class="ecf-footer">

<button
        className="back_button"
        onClick={handleBack}
      >

        ← Back to Section B

      </button>

</div>
    </div>
  );
};

export default ViewBetails;